import { useQuery } from "@apollo/client";

import { ErrorType } from "types/Error";

import { AiIntegrationView, SEARCH_AI_INTEGRATIONS } from "./gql";

type UseSearchAiIntegrationsResult = {
  isPageLoading: boolean;
  error: ErrorType | undefined;
  integrations: AiIntegrationView[];
  refetch: () => void;
};

const useSearchAiIntegrations = (): UseSearchAiIntegrationsResult => {
  const { loading, error, data, refetch } = useQuery(SEARCH_AI_INTEGRATIONS);

  return {
    isPageLoading: loading,
    error,
    integrations: data?.aiIntegrations ?? [],
    refetch,
  };
};

export default useSearchAiIntegrations;
